const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

export default [
  {
    path: 'employees',
    name: 'Employees',
    component: {
      template: '<router-view></router-view>'
    },
    meta: {
      showInMenu: true,
      title: 'Сотрудники',
      menuKey: 'employees',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    children: [
      {
        path: '',
        name: 'Employees.list',
        component: _import('employees/components/list'),
        meta: {
          menuKey: 'employees',
          title: 'Список сотрудников',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'create',
        name: 'Employees.create',
        component: _import('employees/components/create'),
        meta: {
          menuKey: 'employees',
          title: 'Новый сотрудник',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: ':id',
        name: 'Employees.info',
        component: _import('employees/components/info'),
        meta: {
          menuKey: 'employees',
          title: 'Информация о сотруднике',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: ':id/edit',
        name: 'Employees.edit',
        component: _import('employees/components/edit'),
        meta: {
          menuKey: 'employees',
          title: 'Изменить сотрудника',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/employees/routes.js